import { ByRefsisCompNode } from '../../compNodeUtils'
import { structure } from './structureByRefsisCompNode'
import { isGhostComponent } from './isGhostComponentByRefsisCompNode'

export const refConsumptionCompNodes: Record<string, ByRefsisCompNode<any, any>> = {
	structure,
	isGhostComponent,
}
